import React from "react";
import Link from "react-router-dom/Link";

export default function Popup({
  storeNumber,
  BOPIS_Cancel_Retail,
  Extend_Cancel_Retail
}) {
  return (
    <div className="popup">
      <div className="popup__content">
        <div className="popup__header">
          <h1>Keep the Cage Accurate</h1>
        </div>
        <div className="popup__body">
          <p>
            Last year, store <span className="red">{storeNumber}</span> had{" "}
            <span className="red">{BOPIS_Cancel_Retail}</span> interconnected
            sales opportunities that the store could not fulfill due to store
            errors, customer satisfaction or being out of stock. These are true
            missed sales opportunities. If we translate this to the customer's
            in-aisle experience, your store potentially missed out on{" "}
            <span className="red">{Extend_Cancel_Retail}</span> sales due to
            missing tear pads, cashier wait times, or being out of stock.
          </p>
        </div>

        <div className="popup__footer">
          <Link
            to={{
              pathname: "/solution/3",
              state: { prev: true }
            }}
            className="btn"
          >
            <span className="white-background">Continue</span>
          </Link>
        </div>
      </div>
    </div>
  );
}
